import { atom } from "jotai";

import { locationModalAtom } from "./state";

/**
 * UI-only toggles for the "new location" form: whether the name/postal code
 * are auto-derived and whether the new-address panel is open. These aren't
 * part of `LocationFormData` since they're never sent to the API.
 */

export const autoNameAtom = atom(
  (get) => get(locationModalAtom).autoName,
  (_get, set, value: boolean) => {
    set(locationModalAtom, (draft) => {
      draft.autoName = value;
    });
  },
);

export const newAddressToggleAtom = atom(
  (get) => get(locationModalAtom).newAddress.toggle,
  (_get, set, value: boolean) => {
    set(locationModalAtom, (draft) => {
      draft.newAddress.toggle = value;
    });
  },
);

export const autoPostalCodeAtom = atom(
  (get) => get(locationModalAtom).newAddress.autoPostalCode,
  (_get, set, value: boolean) => {
    set(locationModalAtom, (draft) => {
      draft.newAddress.autoPostalCode = value;
    });
  },
);
